// extracted by mini-css-extract-plugin
module.exports = {"container":"DialogBody_container__hbujQ"};